const gender = {
  MALE: '남자',
  FEMALE: '여자',
}

const role = {
  ROLE_USER: '일반',
  ROLE_USER_HASH: 'ROLE_USER',
  ROLE_ADMIN: '어드민',
  ROLE_ADMIN_HASH: 'ROLE_ADMIN',
}

export const Constant = { gender, role }
